module.exports = __webpack_public_path__ + "static/media/Cert II Workplace Skills.da4eab8b.pdf";